import React, { memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { brand, urlBrand, urlCommonAssets, urlPortadaEspeciales } from '../../Constants'; 

const Footer = () => {
    return (
        <footer className="mt-5 especiales-footer">
            <section className="text-center">
                <a className="d-inline-block" href={urlPortadaEspeciales} target="_blank" rel="noreferrer">
                    <LazyLoadImage
                        alt={`Especiales ${brand}`}
                        className="img-fluid px-4 px-md-0 logo-ec-footer"
                        effect="blur"
                        src={`${urlCommonAssets}img/especiales-multimedia.png`}
                    />   
                </a>
            </section>        
            <section className="mt-3 text-center">
                <a className="d-inline-block" href={urlBrand} target="_blank" rel="noreferrer">
                    <LazyLoadImage
                        alt={brand}
                        className="d-block img-fluid px-2 px-md-0"
                        effect="blur"
                        src={`${urlCommonAssets}img/logo-ec-min.svg`}
                    />
                    <span className="d-block text-white footer-brand-name">{`${urlBrand.replace('https://', '')}`}</span>
                </a>
            </section>                
        </footer>
    )
}

export default memo(Footer);
